import React from "react";
import { Link2, ExternalLink } from "lucide-react";
import { TextMessage, LinkPreviewMetadata } from "../../../types/chat";
import styles from "./LinkMessage.module.scss";

interface LinkMessageProps {
  message: TextMessage;
  metadata: LinkPreviewMetadata;
  isOwnMessage?: boolean;
}

const LinkMessage: React.FC<LinkMessageProps> = ({ message, metadata }) => {
  // Support both linkImage and linkImages (backward compatibility)
  const imageUrl = metadata.linkImage || (metadata as any).linkImages;

  return (
    <div className={styles.linkMessage}>
      <a
        href={metadata.linkUrl || (metadata as any).url}
        target="_blank"
        rel="noopener noreferrer"
        className={styles.linkCard}
      >
        {imageUrl && (
          <div className={styles.linkImageContainer}>
            <img src={imageUrl} alt={metadata.linkTitle || (metadata as any).title} className={styles.linkImage} />
          </div>
        )}
        <div className={styles.linkContent}>
          <div className={styles.linkTitle}>{metadata.linkTitle || (metadata as any).title}</div>
          {(metadata.linkDescription || (metadata as any).description) && (
            <div className={styles.linkDescription}>{metadata.linkDescription || (metadata as any).description}</div>
          )}
          <div className={styles.linkSource}>
            <Link2 size={12} />
            <span>{metadata.linkSource || (metadata as any).source}</span>
            <ExternalLink size={12} className={styles.externalIcon} />
          </div>
        </div>
      </a>
    </div>
  );
};

export default LinkMessage;
